const red50 = "#fbe8e8";
const red100 = "#f4b9b9";
const red200 = "#ee9797";
const red300 = "#e76767";
const red400 = "#e24949";
const red500 = "#db1c1c";
const red600 = "#c71919";
const red700 = "#9b1414";
const red800 = "#780f0f";
const red900 = "#5c0c0c";
const reds = {
  red50,
  red100,
  red200,
  red300,
  red400,
  red500,
  red600,
  red700,
  red800,
  red900
};
export {
  reds as default,
  red100,
  red200,
  red300,
  red400,
  red50,
  red500,
  red600,
  red700,
  red800,
  red900
};
//# sourceMappingURL=index.es5.js.map
